/**
 * LicenseKind из API v2 (/api/v2/licenses).
 * В v1 использовался OldLicenseType со значениями 0/1/2, в v2 — 1/2/3.
 * Значения должны совпадать с серверным enum LicenseKind:
 * Perpetual = 1, Temporary = 2, Session = 3.
 */
export enum LicenseKind {
  /** Бессрочная: есть только дата начала, один пользователь. */
  Perpetual = 1,
  /** Срочная: даты начала и окончания, один пользователь. */
  Temporary = 2,
  /** Сессионная: даты начала и окончания, много пользователей, лимит одновременных. */
  Session = 3,
}

export const LICENSE_KINDS: {
  label: string;
  value: LicenseKind;
  code: string;
}[] = [
  { label: "Временная", value: LicenseKind.Temporary, code: "temporary" },
  { label: "Бессрочная", value: LicenseKind.Perpetual, code: "perpetual" },
  { label: "Сессионная", value: LicenseKind.Session, code: "session" },
];

export const LICENSE_KIND_LABELS = LICENSE_KINDS.map(({ label, value }) => ({
  label,
  value,
}));

export type LicenseKindValue = LicenseKind;
